export const CLIENT_DEFAULT = '/client';
export const CLIENT_HOME = '/home';
export const CLIENT_DASHBOARD = '/dashboard';
export const CLIENT_ABS_DASHBOARD = '/abs-dashboard';
export const CLIENT_PORTFOLIO_MONITORING = '/portfolio-monitoring';
export const CLIENT_SECTOR_ANALYSIS = '/sector-analysis';
export const CLIENT_INIT_TRANSACTION_OLD = '/client/initiate';
export const CLIENT_INIT_TRANSACTION = '/initiate';
export const CLIENT_INIT_TRANSACTION_PTC_POOL = '/initiate/ptc';
export const CLIENT_INIT_TRANSACTION_PTC_SUMMARY = '/initiate/ptc/:transId/summary';
export const CLIENT_INIT_TRANSACTION_PTC_PREF = '/initiate/ptc/:transId/pref';
export const CLIENT_INIT_TRANSACTION_PTC_SUCCESS = '/initiate/ptc/:transId/success';

export const CLIENT_POOLS_TRANS_LIST = `${process.env.REACT_APP_POOL_HOST}/:type/transactions`;
export const CLIENT_LOANS_TRANS_LIST = `${process.env.REACT_APP_LOAN_HOST}/:type/transactions`;

export const CLIENT_TRANS_LIST = '/:type/transactions';
export const CLIENT_TRANS_DETAILS = '/:product/:transId';
export const CLIENT_SERVICER_REPORT = '/:product/:transId/servicer-report';
export const CLIENT_REPORTS_LISTS = '/reports';
export const CLIENT_REPORTS_DETAILS = '/reports/:reportType/details';

export const CLIENT_ENTITY_USER_ADD = '/user';

// NCD Routes
export const CLIENT_INIT_TRANSACTION_NCD = '/initiate/ncd';
export const CLIENT_INIT_TRANSACTION_NCD_SUCCESS = '/initiate/ncd/:transId/success';
export const CLIENT_TRANS_NCD_DETAILS = '/ncd/:transId/details';

export const CLIENT_NCD_TASKS_STATUS = '/ncd/:transId/task-status';
export const CLIENT_NCD_TASKS_REPORTER = '/ncd/:transId/task-report';
export const CLIENT_NCD_TASK_GROUP = '/ncd/:transId/task/:altGroupName';
export const CLIENT_NCD_TRANS = '/ncd/:transId';
export const CLIENT_NCD_DOCUMENTS_VIEW = '/ncd/:transId/documents-view';
export const CLIENT_NCD_ATTACHMENTS = '/ncd/:transId/attachments';

// CP Routes
export const CLIENT_INIT_TRANSACTION_CP = '/initiate/cp';
export const CLIENT_INIT_TRANSACTION_CP_SUCCESS = '/initiate/cp/:transId/success';
export const CLIENT_TRANS_CP_DETAILS = '/cp/:transId/details';

export const CLIENT_CP_TASKS_STATUS = '/cp/:transId/task-status';
export const CLIENT_CP_TASKS_REPORTER = '/cp/:transId/task-report';
export const CLIENT_CP_TASK_GROUP = '/cp/:transId/task/:altGroupName';
export const CLIENT_CP_TRANS = '/cp/:transId';
export const CLIENT_CP_DOCUMENTS_VIEW = '/cp/:transId/documents-view';

export const CLIENT_ONBOARDING = `${process.env.REACT_APP_CS_HOST}/client/:entityId/home`;
export const CLIENT_EXPRESS_INTEREST = `${process.env.REACT_APP_CS_HOST}/client/:entityId/express-interest`;

export const CLIENT_DOCUMENT_COLLABORATOR_CP = '/cp/:transId/documents/:docId/editor';
export const CLIENT_DOCUMENT_COLLABORATOR_NCD = '/ncd/:transId/documents/:docId/editor';

export const CLIENT_INIT_TRANSACTION_LEAN = '/initiate/lean';
export const CLIENT_INIT_TRANSACTION_LEAN_SUCCESS = '/initiate/:productType/:transId/success';
